var React = require('react');

function PivotalUiWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pivotal UI A"),React.createElement("polygon",{"points":"0 129.9 75 173.21 90 164.54 90 8.66 75 0 60 8.66 60 129.9 30 112.58 30 25.98 0 43.3 0 129.9","style":{"fill":"#ffffff"},"key":1}),React.createElement("polygon",{"points":"120 25.98 120 147.22 150 129.9 150 43.3 120 25.98","style":{"fill":"#ffffff"},"key":2})]);
}

PivotalUiWhite.displayName = "PivotalUiWhite";

PivotalUiWhite.defaultProps = {"viewBox":"0 0 150 173.21"};

module.exports = PivotalUiWhite;

PivotalUiWhite.default = PivotalUiWhite;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/pivotal_ui_white.svg